import React, { Fragment, ReactElement, ReactNode } from 'react';
import { View, Text, ViewProps } from 'react-native';
import { isElement } from 'react-is';
import { PlatformPadding } from 'src/components/PlatformPadding';
import { Separator } from 'src/components/Separator';
import useStyles from './PanelHeader.styles';

type PanelHeaderProps = ViewProps & {
  left?: ReactNode;
  right?: ReactNode;
  separator?: boolean | ReactElement;
};

export const PanelHeader: React.FC<PanelHeaderProps> = ({
  children,
  left,
  right,
  separator = true,
  style,
  ...props
}) => {
  const s = useStyles();

  return (
    <Fragment>
      <PlatformPadding left={!left} right={!right}>
        <View style={[s.content, style]} {...props}>
          <View style={[s.side, left && (s.left as any)]}>{left}</View>
          <Text style={s.inner} numberOfLines={1}>
            {children}
          </Text>
          <View style={[s.side, right && (s.right as any)]}>{right}</View>
        </View>
      </PlatformPadding>
      {separator &&
        (isElement(separator) ? separator : <Separator padding={true} direction="bottom" />)}
    </Fragment>
  );
};
